var exports = {
  "Vy": "EditHistoryDialogHeaderContainer__J-X9Fp",
  "Rh": "statusLabel__78tnn3",
  "h3": "deleteRevisionButton__wKvL_b",
  "P4": "actorDetailsWrapper__RKK4fK",
  "dj": "userAvatar__yuVQns",
  "Um": "usernameBold__FAxEWZ",
};

module.exports = exports;
